import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";

const Callback = () => {
  const [searchParams] = useSearchParams();

  const authCode = searchParams.get("code");
  const realmId = searchParams.get("realmId");

  const navigate = useNavigate();

  useEffect(() => {
    if (authCode && realmId) {
      axios.post(
        "/assignments/callback/",
        { code: authCode, compId: realmId },
        { withCredentials: true }
      )
        .then((response) => {
          if (window.opener) {
            window.opener.postMessage("quickbooks-auth-success", "*");
            window.close();
          }
        })
        .catch((err) => console.error("Error getting token:", err));
    }
  }, [authCode, realmId, navigate]);

  return <h2>Authenticating...</h2>;
};

export default Callback;

// const { access_token, refresh_token, expires_in } = response.data;
// const expiryTime = new Date().getTime() + expires_in * 1000;
// localStorage.setItem("quickbooks_token", access_token);
// localStorage.setItem("quickbooks_refresh_token", refresh_token);
// localStorage.setItem("quickbooks_token_expiry", expiryTime.toString());
// localStorage.setItem("quickbooks_realmId", realmId);